"use client";

import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { as } from "./themes/as";
import { createContext } from "react";
import type { ReactNode } from "react";


export interface ContextProps {
  children: ReactNode;
}

export const ThemeContext = createContext(as);

export const ThemeContextProvider = ({ children }: ContextProps) => {
  return (
    <ThemeContext.Provider value={as}>
      <ThemeProvider theme={as}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
